import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Box } from "@mui/material";
import type { FC } from "react";
import { FONT_SIZE } from "../../theme/tokens";

/** A footer link's glyph: a pencil edits this person's wage; an arrow opens a settings page. */
export const FooterLinkLabel: FC<{ label: string; icon?: "arrow" | "pencil" }> = ({ label, icon = "arrow" }) => (
	<Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
		{icon === "pencil" && <EditOutlinedIcon aria-hidden sx={{ fontSize: FONT_SIZE.EMPHASIS }} />}
		{label}
		{icon === "arrow" && <ArrowForwardRoundedIcon aria-hidden sx={{ fontSize: FONT_SIZE.EMPHASIS }} />}
	</Box>
);
